import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInternal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.172 8.023a.75.75 0 1 1 0-1.5h5.305v5.306a.75.75 0 1 1-1.5 0V9.084l-4.224 4.224a.75.75 0 0 1-1.06-1.06l4.224-4.225z" />
    <path
      fillRule="evenodd"
      d="M6.248 2.498a3.75 3.75 0 0 0-3.75 3.75v7.504a3.75 3.75 0 0 0 3.75 3.75h7.505a3.75 3.75 0 0 0 3.75-3.75V6.248a3.75 3.75 0 0 0-3.75-3.75zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h7.505a2.25 2.25 0 0 1 2.25 2.25v7.504a2.25 2.25 0 0 1-2.25 2.25H6.248a2.25 2.25 0 0 1-2.25-2.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInternal;
